<template>
  <div class="message">
    <div class="contract">
      <ul>
        <li>
          <div class="radioitems">
            <span class="requiretip">*</span>
            <span class="">合同情况</span>
          </div>
          <div class="radio"
               v-if="reviewState=='0'||reviewState=='1'||reviewState=='4'||reviewState=='5'">
            <mt-radio align="left"
                      v-model="formData.have_type[0]"
                      :options="contractType">
            </mt-radio>
          </div>
          <div v-else>
            <div class="margin-l"><span class="circle"></span>有</div>
            <div class="margin-l"><span class="circle"></span>无</div>
          </div>

        </li>
        <li v-if="formData.have_type[0]==2">
          <div class="remark">
            <span class="requiretip">*</span>
            <span>合同备注</span>
          </div>
          <div class="full-info">
            <textarea class="full-input"
                      v-if="reviewState=='0'||reviewState=='1'||reviewState=='4'||reviewState=='5'"
                      v-model="formData.have_remark[0]"
                      placeholder="请说明合同是否双方盖章，如果不是，请备注什么时候可以上传Boss系统"></textarea>
            <textarea class="full-input"
                      v-else
                      disabled
                      v-model="formData.have_remark[0]"
                      placeholder="请说明合同是否双方盖章，如果不是，请备注什么时候可以上传Boss系统"></textarea>
          </div>
        </li>
        <!-- 报价情况 -->
        <li>
          <div class="radioitems">
            <span class="requiretip">*</span>
            <span class="">报价情况</span>
          </div>
          <div class="radio"
               v-if="reviewState=='0'||reviewState=='1'||reviewState=='4'||reviewState=='5'">
            <mt-radio align="left"
                      v-model="formData.have_type[1]"
                      :options="quoteType">
            </mt-radio>
          </div>
          <div v-else>
            <div class="margin-l"><span class="circle"></span>有</div>
            <div class="margin-l"><span class="circle"></span>无</div>
          </div>
        </li>
        <li v-if="formData.have_type[1]==2">
          <div class="remark">
            <span class="requiretip">*</span>
            <span>报价备注</span>
          </div>
          <div class="full-info">
            <textarea class="full-input"
                      v-if="reviewState=='0'||reviewState=='1'||reviewState=='4'||reviewState=='5'"
                      v-model="formData.have_remark[1]"
                      placeholder="请上传BOSS系统至少有我司盖章版报价"></textarea>
            <textarea class="full-input"
                      v-else
                      disabled
                      v-model="formData.have_remark[1]"
                      placeholder="请上传BOSS系统至少有我司盖章版报价"></textarea>
          </div>
        </li>
        <!-- 报价情况 -->
        <!-- 开工函情况 -->
        <li>
          <div class="radioitems">
            <span class="requiretip">*</span>
            <span class="">开工函情况</span>
          </div>
          <div class="radio"
               v-if="reviewState=='0'||reviewState=='1'||reviewState=='4'||reviewState=='5'">
            <mt-radio align="left"
                      v-model="formData.have_type[2]"
                      :options="quoteType">
            </mt-radio>
          </div>
          <div v-else>
            <div class="margin-l"><span class="circle"></span>有</div>
            <div class="margin-l"><span class="circle"></span>无</div>
          </div>
        </li>
        <li v-if="formData.have_type[2]==2">
          <div class="remark">
            <span class="requiretip">*</span>
            <span>开工函备注</span>
          </div>
          <div class="full-info">
            <textarea class="full-input"
                      v-if="reviewState=='0'||reviewState=='1'||reviewState=='4'||reviewState=='5'"
                      v-model="formData.have_remark[2]"
                      placeholder="请上传甲方签字和日期或者甲方确认盖章版验收函，如果现在提供不了请作说明，并告知下什么时候可以提供"></textarea>
            <textarea class="full-input"
                      v-else
                      disabled
                      v-model="formData.have_remark[2]"
                      placeholder="请上传甲方签字和日期或者甲方确认盖章版验收函，如果现在提供不了请作说明，并告知下什么时候可以提供"></textarea>
          </div>
        </li>
        <!-- 开工函情况 -->
        <!-- 验收函 -->
        <li>
          <div class="radioitems">
            <span class="requiretip">*</span>
            <span class="">验收函情况</span>
          </div>
          <div class="radio"
               v-if="reviewState=='0'||reviewState=='1'||reviewState=='4'||reviewState=='5'">
            <mt-radio align="left"
                      v-model="formData.have_type[3]"
                      :options="acceptanceType">
            </mt-radio>
          </div>
          <div v-else>
            <div class="margin-l"><span class="circle"></span>有</div>
            <div class="margin-l"><span class="circle"></span>无</div>
          </div>
        </li>
        <li v-if="formData.have_type[3]==2">
          <div class="remark">
            <span class="requiretip">*</span>
            <span>验收函备注</span>
          </div>
          <div class="full-info">
            <textarea class="full-input"
                      v-if="reviewState=='0'||reviewState=='1'||reviewState=='4'||reviewState=='5'"
                      v-model="formData.have_remark[3]"
                      placeholder="请上传甲方签字和日期或者甲方确认盖章版验收函，如果现在提供不了请作说明，并告知下什么时候可以提供"></textarea>
            <textarea class="full-input"
                      v-else
                      disabled
                      v-model="formData.have_remark[3]"
                      placeholder="请上传甲方签字和日期或者甲方确认盖章版验收函，如果现在提供不了请作说明，并告知下什么时候可以提供"></textarea>
          </div>
        </li>
        <!-- 验收函 -->
      </ul>
    </div>
    <!-- <div class="leave-info">
      <div class="remark">
        <span class="requiretip"></span>
        <span>留言：</span>
      </div>

      <div class="full-info">
        <textarea class="full-input"
                  placeholder="请输入留言信息"></textarea>
      </div>
    </div> -->
     <div class="leave-info">
            <p style="padding-left: 0.3rem;">留言：</p>
            <ul class="per_say">
              <li v-for="(item,index) in logList" :key="index">
                <span style="margin-right:0.4rem">{{item.name}}</span>
                <span style="margin-right:0.4rem">{{item.created_at?(item.created_at).slice(0,10):''}}</span>
                <span>{{item.remark}}</span>
              </li>
            </ul>
          </div>
  </div>

</template>
<script>

  import { MessageBox, } from 'mint-ui';
  import Vue from 'vue'
  export default {
    props: {
      editBaseData: {
        type: Object,
        default: () => {
          return {}
        }
      },
      operationStatus: {//操作步骤
        type: String,
        default: () => {
          return '0'
        }
      },
    },
    data () {
      return {
        formData: {
          have_type: ['1', '1', '1', '1'],
          have_remark: ['', '', '', ''],
        },
        reviewState: '',
        logList:[],
        ruleValidate: {//验证
          contract_remark: {
            require: false,
            mesg: '合同备注'
          },
          quote_remark: {
            require: true,
            mesg: '报价备注'
          },

        },
        contractType: [
          {
            label: '有',
            value: '1',
          },
          {
            label: '无',
            value: '2'
          },
        ],
        quoteType: [
          {
            label: '有',
            value: '1',
          },
          {
            label: '无',
            value: '2'
          },
        ],
        startLetterType: [
          {
            label: '有',
            value: '1',
          },
          {
            label: '无',
            value: '2'
          },
        ],
        acceptanceType: [
          {
            label: '有',
            value: '1',
          },
          {
            label: '无',
            value: '2'
          },
        ],


      }
    },
    methods: {
      // 验证当前form带requiretip 类名的字段
      checkField () {
        let fieldState = true
        let keyArr = Object.keys(this.ruleValidate)
        for (let i = 0; i < keyArr.length; i++) {
          if (this.ruleValidate[keyArr[i]].require && this.formData[keyArr[i]] == '') {
            MessageBox('提示', this.ruleValidate[keyArr[i]].mesg)
            fieldState = false
            break
          }
        }
        // 如果验证通过则返回当前组件的forData
        if (fieldState) {
          return this.formData
        }
      }
    },
    created () {
      this.logList=this.$route.query.logData
      this.reviewState = window.localStorage.getItem('reviewState')
      if (this.operationStatus == '1' && this.editBaseData) {//
        this.formData.have_type = this.editBaseData.have_type
        this.formData.have_remark = this.editBaseData.have_remark
      }
    },
  }
</script>
<style scoped>
  .message {
    padding-bottom: 1.5rem;
    font-size: 0.4rem;
  }
  .contract {
    margin-top: 0.12rem;
    background: #fff;
  }
  .leave-info {
    background: #fff;
    padding: 0 0.06rem;
  }
  .radioitems {
    padding-top: 0.4rem;
    height: 1.1rem;
    margin-left: 0.1rem;
  }
  .radio /deep/ .mint-cell-wrapper {
    padding: 0;
    font-size: 0.4rem;
  }
  .requiretip {
    color: #fb2e45;
  }
  .remark {
    padding-left: 0.1rem;
    height: 1.2rem;
    line-height: 1.2rem;
  }
  .full-info {
    height: 2.725rem;
    padding: 0 0.4rem;
  }
  .full-input {
    width: 100%;
    height: 100%;
    background: #f7f7f7;
    padding: 0.1rem;
  }
  .margin-l {
    padding-top: 0.3rem;
    margin: 0 0.2rem;
    height: 1rem;
  }
  .circle {
    margin-right: 0.2rem;
    display: inline-block;
    border: 1px solid #ccc;
    border-radius: 50%;
    width: 0.5rem;
    height: 0.5rem;
    position: relative;
    top: 0.1rem;
  }
 .per_say{
    padding:0.3rem;
  }
.per_say>li{
  min-height: 1rem;
}
</style>


// WEBPACK FOOTER //
// src/components/Ticket/TicketMessage.vue